// extracted by mini-css-extract-plugin
module.exports = {"container":"ForgotPassword_container__3Ut8r","form-container":"ForgotPassword_form-container__2pu03","signup-forgot":"ForgotPassword_signup-forgot__1gicn"};